import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

let   teamSlideshowBlock  = document.querySelectorAll('.block.team-slideshow');
let   teamSlideshowSwiper = {};


Array.from( teamSlideshowBlock ).forEach( (block) => {
  teamSlideshowSwiper[block.dataset.id] = new Swiper(
  block.querySelector('.swiper'),
    {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 500,
      effect: 'fade',
      pagination: {
        el: '.pagination',
        type: 'bullets',
        clickable: true
      },
    }
  );
} )

